function googlePlusShareThisPage(e) {
  e.preventDefault();
  let href= `https://plus.google.com/share?url=${document.location.href}`;
  window.open(href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  return false;
}

module.exports = {
  googlePlusShareThisPage
}



// WEBPACK FOOTER //
// ./src/js/google-plus.js